<template>
  <div class="eight wide column pl-0 pt-0 pb-05">
    <div class="is-uppercase">Total por gpu de orden ascencedentes</div>
    <canvas id="gpu_totals_"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js";
import { groupBy } from "lodash";

export default {
  name: "GpuTotalsGraph",
  props: { gpus: Array },
  data() {
    return {
      requests: [],
    };
  },
  mounted() {
    // this.graph();
  },
  computed: {
    grouped() {
      let vm = this;
      if (vm.requests && vm.requests.length > 0) {
        // Calculating week of year
        let grps = groupBy(vm.requests, (rq) => {
          let type = rq.setup.gpu_type;
          let trgt = vm.gpus.find((g) => {
            return g.graphic_card_id == type;
          });
          if (trgt) return trgt.setup.name;
          else return "?";
        });

        return grps;
      } else return [];
    },
  },
  methods: {
    graph() {
      let vm = this;
      const labels = Object.keys(vm.grouped).map((k) => {
        return k;
      });
      const dt = Object.keys(vm.grouped).map((k) => {
        return vm.grouped[k].length;
      });

      // const labels = ["January", "February", "March", "April", "May", "June"];

      const data = {
        labels: labels,
        datasets: [
          {
            label: vm.$t("codes quantity"),
            data: dt,
            backgroundColor: [
              "rgba(255, 99, 132, 0.2)",
              "rgba(255, 159, 64, 0.2)",
              "rgba(255, 205, 86, 0.2)",
              "rgba(75, 192, 192, 0.2)",
              "rgba(54, 162, 235, 0.2)",
              "rgba(153, 102, 255, 0.2)",
              "rgba(201, 203, 207, 0.2)",
            ],
            borderColor: [
              "rgb(255, 99, 132)",
              "rgb(255, 159, 64)",
              "rgb(255, 205, 86)",
              "rgb(75, 192, 192)",
              "rgb(54, 162, 235)",
              "rgb(153, 102, 255)",
              "rgb(201, 203, 207)",
            ],
            borderWidth: 1,
          },
        ],
      };

      const config = {
        type: "bar",
        data: data,
        options: {
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        },
      };
      // eslint-disable-next-line no-unused-vars
      const myChart = new Chart(document.getElementById("gpu_totals_"), config);
      // console.log(myChart);
    },
    setRequests(requests) {
      this.requests = requests;
      this.graph();
    },
  },
};
</script>

<style scoped>
/* @import url("https://nworkforce.com/librerias/css/fonts/fonts.css"); */

/*  SPACING   */
.py-05 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.m-0 {
  margin: 0 !important;
}
.my-0 {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}
.px-gen {
  padding-right: 2rem !important;
  padding-left: 2rem !important;
}
.pl-0 {
  padding-left: 0 !important;
}

/*  FONTS   */
.has-text-centered {
  text-align: center !important;
}
.has-text-left {
  text-align: left !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}
.fdinpro {
  font-family: "DINPro" !important;
}

/*  GRAFICAS    */
.charts-nvidia div .is-uppercase {
  background-color: #666666 !important;
  color: white !important;
  padding: 0.5rem 1rem 0.5rem;
}

/* INFORMACION BUNDLE*/
.info-bundle .ten table tbody tr td {
  text-align: center;
  font-size: 90% !important;
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}
.info-bundle .ten table tbody tr td button {
  font-size: 90% !important;
}
.info-bundle .ten table tbody tr .six.wide button {
  border-radius: 2rem;
}
.info-bundle .six table tbody tr td {
  text-align: left;
  font-size: 90% !important;
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}
.info-bundle .six table tbody tr td button {
  font-size: 90% !important;
}
.info-bundle .six table tbody tr .six.wide button {
  border-radius: 2rem;
}
.ibundle-button-green {
  background-color: #666666 !important;
  color: white !important; /*width: 100%;*/
  font-family: "DINPro" !important;
  font-weight: 500;
}
.ibundle-button-green.active {
  background-color: #365a0c !important;
}
.ibundle-button-green:hover {
  background-color: #365a0c !important;
}

/*  MODAL FORMS   */
.default-header-green {
  border-bottom: 2pt solid #365a0c !important;
  font-weight: 300;
  font-size: 1.5rem !important;
}
.modal-button-green {
  background-color: #365a0c !important;
  color: white !important; /*width: 100%;*/
  font-family: "DINPro" !important;
  font-weight: 500;
}
.modal-button-green:hover {
  background-color: rgb(118, 185, 0) !important;
}

/*  HISTORIAL DE ENVIOS */
.sb-button {
  display: flex !important;
  flex-direction: row;
  text-align: left !important;
  background-color: transparent !important;
  color: #606060 !important;
}
.sb-button:hover {
  color: white !important;
  background-color: #365a0c !important;
}
.sb-button.active {
  color: white !important;
  background-color: #365a0c !important;
}
.pre-sb-button {
  flex: 20%;
}
.name-sb-button {
  flex: 80%;
}
</style>
